import React from "react";
import { Draggable } from "react-beautiful-dnd";
import formatNumber from "../../utils/formatNumber";
import { AiOutlineClose } from "react-icons/ai";

function GeoclientTour({tour, index, onRemove}) {
  return (
    <Draggable
      draggableId={tour.tour_id.toString()}
      index={index}
    >
      {(provided, snapshot) => (
        <div
          className={`geoclient__tours-item ${
            snapshot.isDragging ? "geoclient__tours-item_dragactive" : ""
          }`}
          data-id={tour.tour_id}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
        >
          <span className="geoclient__tours-item-text">
            {tour.name} (<b>{tour.country}</b>) {tour.nights} ночей{" "}
          </span>
          <div className="geoclient__tours-item-column">
            <span className="price">{formatNumber(tour.initial_price)}</span>
            <p className="remove-tour" onClick={() => onRemove(tour.tour_id)}>
              <AiOutlineClose />
            </p>
          </div>
        </div>
      )}
    </Draggable>
  );
}

export default GeoclientTour;
